<template>
  <v-row class="ma-0">
    <v-col :cols="showOnDialog ? 12 : 6">
      <CPTInput
        v-model="member.nome"
        label="Nome completo*"
        :required="!member.isEmpty()"
      />
    </v-col>
    <v-col :cols="showOnDialog ? 6 : 3">
      <CPTSelect
        v-model="member.kinship"
        label="Grau de parentesco*"
        :items="kinshipDegrees"
        item-text="nome"
        return-object
        :required="!member.isEmpty()"
        :validator="[
          v => member.isEmpty() || !isEmpty(v) || 'Este campo é obrigatório'
        ]"
      />
    </v-col>

    <v-col :cols="showOnDialog ? 6 : 3">
      <CPTInput v-model="member.pisPasep" label="PIS/PASEP" counter />
    </v-col>

    <v-col :cols="showOnDialog ? 7 : 6">
      <CPTInput v-model="member.workplace.name" label="Local de trabalho" />
    </v-col>

    <v-col :cols="showOnDialog ? 5 : 2">
      <CPTInput
        v-model="member.workplace.phone"
        label="Telefone da empresa"
        :validator="[
          t => !t || t.length === 15 || t.length === 14 || 'Telefone inválido'
        ]"
        validate-on-blur
        :disabled="!member.workplace.name"
        v-maska="['(##) #####-####', '(##) ####-####']"
      />
    </v-col>

    <v-col :cols="showOnDialog ? 6 : 2">
      <CPTInput
        v-model="member.workplace.start"
        label="Horário de entrada"
        v-maska="'##:##'"
        :disabled="!member.workplace.name"
        :validator="[time => validateTime(time) || 'Horário inválida']"
      />
    </v-col>
    <v-col :cols="showOnDialog ? 6 : 2">
      <CPTInput
        v-model="member.workplace.end"
        :disabled="!member.workplace.name"
        label="Horário de saída"
        v-maska="'##:##'"
        :validator="[time => validateTime(time) || 'Horário inválida']"
      />
    </v-col>
    <v-col v-if="showRendaField" cols="12">
      <CPTInput
        v-model="member.income"
        :disabled="!member.workplace.name"
        label="Renda Mensal"
        v-maska="rendaMask"
      />
    </v-col>
    <v-col :cols="showOnDialog ? 12 : 6">
      <CPTSelect
        v-model="documentType"
        label="Documento*"
        required
        :items="[
          'CPF',
          'Certidão de Nascimento (Nova - 32 digitos)',
          'Certidão de Nascimento (Antiga - termo/livro/folha)'
        ]"
        @input="
          member.cpf = member.certidaoNascimento = member.certidaoNascimentoTermo = member.certidaoNascimentoLivro = member.certidaoNascimentoFolha = null
        "
      />
    </v-col>

    <v-col :cols="showOnDialog ? 12 : 6">
      <CPTInput
        v-if="documentType === 'CPF'"
        v-maska="'###.###.###-##'"
        v-model="member.cpf"
        label="CPF*"
        :required="!member.isEmpty()"
        validate-on-blur
        :validator="[
          cpf => member.isEmpty() || isValidCPF(cpf) || 'CPF inválido'
        ]"
      />
      <CPTInput
        v-else-if="
          documentType === 'Certidão de Nascimento (Nova - 32 digitos)'
        "
        v-maska="'################################'"
        v-model="member.certidaoNascimento"
        label="Certidão de nascimento*"
        :required="!member.isEmpty()"
        counter="32"
      />
      <v-row
        class="ma-0"
        v-if="
          documentType === 'Certidão de Nascimento (Antiga - termo/livro/folha)'
        "
      >
        <v-col cols="4" class="pt-0 pl-0">
          <CPTInput
            v-model="member.certidaoNascimentoTermo"
            label="Termo"
            :required="!member.isEmpty()"
            counter="07"
          />
        </v-col>
        <v-col cols="4" class="pt-0">
          <CPTInput
            v-model="member.certidaoNascimentoLivro"
            label="Livro"
            :required="!member.isEmpty()"
            counter="05"
          />
        </v-col>
        <v-col cols="4" class="pt-0 pr-0">
          <CPTInput
            v-model="member.certidaoNascimentoFolha"
            label="Folha"
            :required="!member.isEmpty()"
            counter="03"
          />
        </v-col>
      </v-row>
    </v-col>

    <v-col class="pt-0" :cols="removeButton ? 6 : 12">
      <v-switch
        v-model="showAddressForm"
        label="Membro possui endereço diferente do aluno"
        @change="getStates()"
      />
    </v-col>

    <v-col
      v-if="removeButton"
      cols="12 d-flex justify-end"
      class="d-flex justify-end"
    >
      <CPTBtn
        label="Excluir Membro"
        icon="mdi-delete"
        @click="onClickRemoveButton"
        color="red"
      />
    </v-col>

    <template v-if="showAddressForm">
      <v-col :cols="showOnDialog ? 12 : 2">
        <CPTInput
          v-model="cep"
          label="CEP*"
          required
          v-maska="'#####-###'"
          @maska="cepRawValue = $event.target.dataset.maskRawValue"
        />
      </v-col>
      <v-col :cols="showOnDialog ? 8 : 4">
        <CPTInput v-model="member.endereco.rua" label="Rua*" required />
      </v-col>
      <v-col :cols="showOnDialog ? 4 : 2">
        <CPTInput
          v-model="member.endereco.numero"
          v-maska="'#*'"
          label="Número"
        />
      </v-col>
      <v-col :cols="showOnDialog ? 6 : 4">
        <CPTInput v-model="member.endereco.bairro" label="Bairro*" required />
      </v-col>
      <v-col cols="6">
        <CPTAutocomplete
          v-model="state"
          label="Estado*"
          @change="getCities(true)"
          :items="states"
          noDataText="Estado não encontrado"
          item-text="nome"
          clearable
          return-object
          required
        />
      </v-col>
      <v-col cols="6">
        <CPTAutocomplete
          v-model="member.endereco.cidade"
          label="Cidade*"
          :items="cities"
          item-text="nome"
          noDataText="Cidade não encontrada"
          return-object
          clearable
          required
        />
      </v-col>
      <v-col :cols="showOnDialog ? 6 : 12">
        <CPTInput v-model="member.endereco.complemento" label="Complemento" />
      </v-col>
    </template>

    <v-dialog v-model="dialogExclusao" width="750">
      <v-card color="grey lighten-5">
        <v-card-title class="text-h5 primary white--text">
          {{
            `Deseja excluir ${member.nome || "esse membro"} do grupo familiar?`
          }}
        </v-card-title>

        <v-card-text class="pt-3">
          Essa ação não poderá ser desfeita
        </v-card-text>

        <v-divider />

        <v-card-actions class="d-flex justify-end py-3">
          <CPTBtn label="Não" @click="dialogExclusao = false" />
          <CPTBtn
            label="Sim"
            @click="$emit('remove'), (dialogExclusao = false)"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import CPTInput from "@/components/Input";
import CPTSelect from "@/components/Select";
import CPTAutocomplete from "@/components/Autocomplete";
import CPTBtn from "@/components/Btn";
import validateTime from "@/utils/validateTime";
import FamilyMember from "@/models/FamilyMember.js";
import Address from "@/models/Address.js";
import Workplace from "@/models/Workplace.js";
import { isEmpty } from "lodash";
import { cpf } from "cpf-cnpj-validator";
// import api_cep from "plugins/api_cep";
export default {
  name: "form-member-family",
  components: {
    CPTInput,
    CPTSelect,
    CPTAutocomplete,
    CPTBtn
  },
  props: {
    removeButton: {
      type: Boolean,
      default: false
    },
    value: {
      type: FamilyMember,
      default: new FamilyMember()
    },
    showOnDialog: {
      type: Boolean,
      default: false
    },
    showRendaField: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    // emitirCEP(value) {
    // if (value.length === 8) {
    // this.$emit("startSearchAddress");
    // this.loading = true;
    // api_cep
    // .buscar(value)
    // .then(endereco => {
    // if (endereco.erro) {
    // this.errorMessage();
    // return;
    // }
    // this.completarEndereco(endereco);
    // })
    // .catch(() => {
    // this.errorMessage();
    // });
    // }
    // },

    this.getKinshipDegrees();
  },

  data() {
    return {
      cities: [],
      dialogExclusao: false,
      documentType: null,
      kinshipDegrees: [],
      showAddressForm: this.member ? !this.member.endereco.isEmpty() : false,
      state: null,
      cepRawValue: null,
      cep: null,
      workplace: new Workplace(),
      rendaMask: ["#.###,##", "##.###,##", "###,##"]
    };
  },
  computed: {
    member: {
      get() {
        return this.value;
      },
      set(member) {
        this.$emit("input", member);
      }
    },

    states() {
      return this.$store.state.address.states;
    }
  },
  methods: {
    async getCities(clearMemberCity) {
      if (clearMemberCity) this.member.endereco.cidade = null;

      if (!this.state) return;

      this.cities = await this.$http
        .get(`cidade?estado_id=${this.state.id}`)
        .catch(error => this.showMessage(error, "error"));
    },
    async getKinshipDegrees() {
      this.kinshipDegrees = await this.$http
        .get("parentesco")
        .catch(error => this.showMessage(error, "error"));
    },
    getStates() {
      if (!this.states) this.$store.dispatch("address/getStates");
    },
    isEmpty,
    isValidCPF: cpf.isValid,

    onClickRemoveButton() {
      if (this.member.isEmpty()) return this.$emit("remove");

      this.dialogExclusao = true;
    },
    validateTime
  },
  watch: {
    showAddressForm() {
      this.member.endereco = new Address();
      this.cep = this.member.endereco.cep;
      this.cepRawValue = this.member.endereco.cep;
    },
    cep() {
      this.member.endereco.cep = this.cepRawValue;
    },
    "member.workplace.name": function(oldValue) {
      if (!oldValue) {
        this.member.workplace = new Workplace();
      }
    }
  }
};
</script>
